<template>
  <div class="div" v-loading="loading">
    <div class="div-content">
      <div class="wh100" style="overflow: auto">
        <el-card class="content-list" header="设备分析">
          <div style="width: 50%; margin-left: 25%">
            <div class="search-item">
              <div class="label">日期范围:</div>
              <el-date-picker
                v-model="searchData.YearMonth"
                type="monthrange"
                range-separator="至"
                :clearable="false"
                value-format="yyyyMM"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                class="flex1"
              >
              </el-date-picker>
            </div>
            <div class="search-item">
              <span class="label">位置范围: </span>
              <el-checkbox-group
                v-model="searchData.BuildingId"
                class="flex1"
                @change="BuildingChange"
              >
                <el-checkbox
                  v-for="item in BuildingList"
                  :key="item.Id"
                  :label="item.Id"
                  class="search-checkbox"
                >
                  {{ item.Name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="search-item">
              <span class="label">类型范围: </span>
              <el-checkbox-group
                v-model="searchData.DeviceType"
                class="flex1"
                @change="DeviceTypeChange"
              >
                <el-checkbox
                  v-for="item in DeviceTypeList"
                  :key="item.Id"
                  :label="item.Id"
                  class="search-checkbox"
                >
                  {{ item.DicName }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="search-item">
              <span class="label">分析内容: </span>
              <el-checkbox-group
                v-model="selectedContents"
                class="flex1 content-selector"
              >
                <el-checkbox
                  v-for="item in dataInfo.Content"
                  :key="item.Id"
                  :label="item.Id"
                  class="content-checkbox"
                >
                  {{ item.Name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="search-item">
              <span class="label"></span>
              <el-button
                type="primary"
                style="width: 300px; line-height: 40px; font-size: 16px"
                class="flex1"
                @click="openInfo"
                >开始分析</el-button
              >
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <AiWorkInfo ref="AiWorkInfo"></AiWorkInfo>
  </div>
</template>
<script>
import moment from 'moment'
import AiWorkInfo from '@/components/AiWorkInfo/AiWorkInfo.vue'
export default {
  data() {
    return {
      loading: false,
      searchData: {
        YearMonth: [
          moment().subtract(11, 'month').format('YYYYMM'),
          moment().format('YYYYMM'),
        ],
        BuildingId: [],
        BuildingInfo: [],
        DeviceType: [],
        DeviceTypeInfo: [],
      },
      InfoList: [],
      isData: false,
      dataInfo: {
        Content: [],
      },
      selectedContents: [], // 新增用于存储选中的内容
      BuildingList: [],
      DeviceTypeList: [],
    }
  },
  props: {},
  components: { AiWorkInfo },
  methods: {
    BuildingChange(v) {
      console.log(v)
      this.searchData.BuildingInfo = this.BuildingList.filter((item) => {
        return v.includes(item.Id)
      })
    },
    DeviceTypeChange(v) {
      console.log(v)
      this.searchData.DeviceTypeInfo = this.DeviceTypeList.filter((item) => {
        return v.includes(item.Id)
      })
      console.log(this.searchData.DeviceTypeInfo)
    },
    getList() {
      this.$http.post('/PB/PB_Project/GetPosition', {}).then((res) => {
        if (res.Success) {
          this.BuildingList = res.Data
          this.searchData.BuildingId = res.Data.map((item) => item.Id)
          this.searchData.BuildingInfo = [...res.Data]
        }
      })
      this.$http
        .post('/PB/PB_Project/GetDictionaryMainList', {})
        .then((res) => {
          if (res.Success) {
            this.DeviceTypeList = res.Data
            this.searchData.DeviceType = res.Data.map((item) => item.Id)
            this.searchData.DeviceTypeInfo = [...res.Data]
          }
        })
    },
    openInfo() {
      console.log(this.selectedContents)
      if (!this.selectedContents.length) {
        return this.$notify.error('请至少选择一个类别进行分析')
      }
      let items = this.dataInfo.Content.filter((item) => {
        return this.selectedContents.includes(item.Id)
      })
      let obj = {
        Id: this.dataInfo.Id,
        Aiinterface: this.dataInfo.Aiinterface,
        Name: this.dataInfo.Name,
        Content: [...items],
      }
      let search = {
        StartYearMonth: this.searchData.YearMonth[0] || '',
        EndYearMonth: this.searchData.YearMonth[1] || '',
        DeviceType: this.searchData.DeviceType
          ? this.searchData.DeviceType.join(',')
          : '',
        BuildingId: this.searchData.BuildingId
          ? this.searchData.BuildingId.join(',')
          : '',
        BuildingInfo: this.searchData.BuildingInfo,
        DeviceTypeInfo: this.searchData.DeviceTypeInfo,
      }
      console.log(items, '2222222')
      this.$refs.AiWorkInfo.openInfo('', obj, search)
    },
    getDataInfo() {
      this.loading = true
      this.$http
        .post(
          '/AnalysisManage/Analysis_Template/GetAnalysisTemplateData?Id=' +
            this.$route.name,
          {}
        )
        .then((res) => {
          this.loading = false

          //   "Name" 图表标题名称
          //   "Sort": 排序
          //   "DataInterface" 图表接口,
          //   "DataImgType"  图表类型  line 折线图 bar 柱状图 pie 饼图  sunburst 旭日图,
          //   "DataType": "2"  图标数据返回的数据结构类型 1 一维数组 2 二维数组  3 二维数组 0 树结构 ,
          //   "DataImgQuantity": 图表的数量 默认1 ,
          //   "Aiinterface": AI分析接口 总结接口

          if (res.Success) {
            this.dataInfo = res.Data
            res.Data.Content.forEach((item) => {
              this.selectedContents.push(item.Id)
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  mounted() {},
  created() {
    this.getDataInfo()
    this.getList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div {
  padding: 10px 20px;
}
.div-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  position: relative;
}

.content-checkbox {
  width: 100%;

  padding: 18px 28px;
  margin-bottom: 10px;
}
.content-checkbox .content-name {
  font-weight: 500;
  font-size: 16px;
  color: #333;
  margin-left: 6px;
}
.el-checkbox.is-checked.content-checkbox {
  border: 1px solid #409eff;
  background: #e6f7ff;
}
.el-checkbox.is-checked .content-name {
  color: #409eff;
}
.content-list {
  width: 60%;
  margin-left: 20%;
  margin-top: 50px;
}
.search-item {
  display: flex;
  // align-items: center;
  margin-top: 20px;
}
.label {
  display: inline-block;
  width: 100px;
  font-size: 14px;
  margin-right: 10px;
}
.search-checkbox {
  margin-right: 20px;
  margin-bottom: 10px;
}
</style>
